import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import { ApiError } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export interface ThemeWithCount {
  name: string;
  count: number;
}

export const useGetCaseThemes = (caseId: string | null) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<ThemeWithCount[]>(
    [QueryEntity.CaseThemes, caseId],
    async () => {
      const res = await fetch(`${APIBaseChronos}/api/case/${caseId}/themes`, fetchConfigGET);
      if (!res.ok) {
        const error = await res.json();
        throw new ApiError(error.code, error.message);
      }
      return await res.json();
    },
    {
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!caseId,
    },
  );
};
